export default function containerReducer(state) {
  if (state === undefined) {
    return {};
  }

  return state;
}
